import { ApiController } from 'config';
import { get, post, put } from '..';

type RatesParams = {
  discountId: number;
  userId: number;
};

type DislikeDiscountParams = RatesParams & {
  comment: string;
};

export type LikeCounterVariants = 'LIKE' | 'DISLIKE' | null;

export type RateType = {
  rateType: LikeCounterVariants;
};

export const setLikeDiscount = ({ discountId, userId }: RatesParams) => {
  return post({
    url: `/${ApiController.rates}/like?discountId=${discountId}&userId=${userId}`,
    body: {},
  });
};

export const setDislikeDiscount = ({
  discountId,
  userId,
  comment,
}: DislikeDiscountParams) => {
  const params = new URLSearchParams({
    discountId: discountId.toString(),
    userId: userId.toString(),
    comment,
  }).toString();

  return post({
    url: `/${ApiController.rates}/dislike?${params}`,
    body: {},
  });
};

type DiscountRatingParams = {
  discountId: number;
  rating: number;
  comment?: string;
};

export type DiscountRatingResponse = {
  discountId: number;
  userId: number;
  userRating: number;
  comment: string | null;
  averageRating: number;
  commentPromptRequired: boolean;
  commentPromptMessage: string | null;
};

export const setDiscountRating = ({
  discountId,
  rating,
  comment,
}: DiscountRatingParams) => {
  return put<DiscountRatingResponse>({
    url: `/${ApiController.discount}/${discountId}/rating`,
    body: comment === undefined ? { rating } : { rating, comment },
  });
};

export const getRates = ({
  discountId,
  userId,
}: RatesParams): Promise<RateType> => {
  return get({
    url: `/${ApiController.rates}?discountId=${discountId}&userId=${userId}`,
  });
};
